export interface ICompany {
  id?: string; 
  ruc: number;
  name?: string;
  area?: string;
  address?: string;
  email?: string;
  phone?: string;
  segment?: string;
}

export interface IAdmin {
  firstName?: string;
  lastName?: string;
  docType: string;
  docNumber: string;
  email?: string;
  charge?: string;
  phone?: string;
  terms?: boolean;
}

export class Account {
  company: ICompany;
  admin: IAdmin;

  constructor() {
    this.initCompany();
    this.initAdmin();
  }

  initCompany() {
    this.company = {
      ruc: null,
      name: "",
      area: "",
      address: "",
      email: "",
      phone: "",
    };
  }

  initAdmin() {
    this.admin = {
      firstName: "",
      lastName: "",
      docType: "",
      docNumber: "",
      email: "",
      charge: "",
      phone: "",
      terms: false,
    };
  }

}
